import { AppSubNav } from "@components/widgets/AppSubNav/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { withId } from "@src/components/HOC/with-id/withId";
import { PageGlobalCreditAccountDetail } from "@src/components/modules/credit-account/global-account-detail";
import { createFileRoute } from "@tanstack/react-router";

const Page = withId(({ id }) => (
  <MainLayout
    title={t`Expense credit account`}
    navigation={<AppSubNav defaultBackButtonUrl="/credit-accounts/global" />}
  >
    <PageGlobalCreditAccountDetail id={id} />
  </MainLayout>
));

export const Route = createFileRoute("/credit-accounts/global-detail")({
  component: Page,
});
